export default __webpack_public_path__ + "static/media/agri-dev2.b8d15bff.jpg";